import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import template from '@/../templates/sent-invite.hbs';
import _ from 'underscore';
var alertCh = Radio.channel('alerts');

var globalCh = Radio.channel('global');

var SentInviteItemView = Marionette.View.extend({
    template: Handlebars.compile(template),
    tagName: 'div',
    className: 'col-md-3 col-sm-4',
    ui: {
        revoke: '.revoke',
        invited_by: '.invited-by',
        roles: '.roles'
    },
    regions: {
        invited_by_region: '@ui.invited_by',
        roles_region: '@ui.roles'
    },
    events: {
        'click @ui.revoke': 'revoke'
    },
    modelEvents: {
        'change': 'render'
    },
    render_invited_by: function() {
        var invited_by_view;
        var invited_by = this.model.rel.get('creator');
        
        if (!invited_by) return;

        invited_by_view = new Marionette.View({
            model: invited_by,
            tagName: 'span',
            template: Handlebars.compile('{{username}}')
        });
        this.showChildView('invited_by_region', invited_by_view);
    },
    render_roles: function() {
        var roles_view;
        var roles = this.model.rel.get('roles');

        if (!roles) return;

        roles_view = new Marionette.View({
            tagName: 'span',
            template: Handlebars.compile('{{#each roles}}{{this.attributes.name}}{{#unless @last}}, {{/unless}}{{/each}}'),
            templateContext: function() {
                return { roles: roles };
            }
        });
        this.showChildView('roles_region', roles_view);
    },
    initialize: function() {
        _.bindAll(this, 'render_invited_by');
    },
    templateContext: function() {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');

        var can_update_invites = active.permits(
            primary, 
            'update_invitations'
        );

        return {
            can_update_invites: can_update_invites
        };
    },
    onRender: function() {
        var options = { delay: { show: 500, hide: 100 }, container: 'body'};
        this.ui.revoke.tooltip(options);

        this.listenTo(this.model.rel, 'change:creator', this.render_invited_by);
        this.render_invited_by();

        this.listenTo(this.model.rel, 'change:roles', this.render_roles);
        this.render_roles();
    },
    revoke: function(){
        var grantee_name = this.model.get('invitee');
        this.ui.revoke.tooltip('destroy');
        this.model.destroy().then(
            function(){
                var message = 'You have revoked the invitation to account '
                                + grantee_name;
                alertCh.request('showAlert', { message: message, messageType: 'warning' });

            },
            function(resp){
                var message = resp.responseJSON.errors[0].title + ' : ' + resp.responseJSON.errors[0].detail;
                alertCh.request('showAlert', { message: message, messageType: 'danger' });
            }
        );
    },
});

export default SentInviteItemView;

